module.exports = __webpack_public_path__ + "img/coverage-3.1e973ec0.svg";